import React from "react";
import { NavLink } from "react-router-dom";
import "./section-tabs.scss";

const SectionTabs = ({ tabs = [] }) => (
  <nav className="section-tabs">
    {tabs.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end={tab.end}
        className={({ isActive }) => (isActive ? "active" : "")}
      >
        {tab.label}
      </NavLink>
    ))}
  </nav>
);

export default SectionTabs;
